module.exports = __webpack_public_path__ + "img/Skirt-Back-B7-Da-Ha.ae05f170.png";